import { Stepper } from 'components/UI'
import { StepType } from 'components/UI/CustomUI/organisms/Stepper/types'
import { approvalActions, territoriesActions } from 'ducks/actions'
import { ApprovalValue } from 'ducks/approval/types'
import { useAppDispatch } from 'ducks/hooks'
import {
  getApprovalStep,
  getApprovalValues,
  getEstimate,
  getTerritory,
  getUserPrimaryEmail
} from 'ducks/selectors'
import { useSelector } from 'react-redux'
import ContactBanner from '../../components/ContactBanner'
import UnclickableStep from '../../components/UnclickeableStep'
import Step4Agent from '../Agent/Step4/Step4'
import Step1Homeowner from './Step1/Step1'
import Step3Homeowner from './Step3/Step3'
import { useEffect } from 'react'

const HomeownerStepper = () => {
  const dispatch = useAppDispatch()
  const activeStep = useSelector(getApprovalStep)
  const { agentAsHomeownerRepresentative, financingOption } = useSelector(
    getApprovalValues()
  )
  const estimate = useSelector(getEstimate())
  const territory = useSelector(getTerritory())

  const userEmail = useSelector(getUserPrimaryEmail)
  const approvalInProgress = estimate?.properties.contacts?.some(
    (contact) => contact?.email !== userEmail && contact?.approvalFlowInProgress
  )

  const isBosscatFinancing = financingOption === 'Bosscat'
  const isBelow10K = estimate?.properties?.totalWithTax && estimate?.properties?.installmentThreshold && estimate?.properties?.totalWithTax < estimate?.properties?.installmentThreshold
  const isFinancingRejected = estimate?.properties.financingRejectedOn

  const steps: StepType[] = [
  ]



  if (!estimate?.properties.financingApprovedOn) {
    steps.push({
      content: (
        <Step1Homeowner />
      ),
      disableBack: true,
    },)
  }

  steps.push({
    content: <Step3Homeowner />,
    disableBack: true,
  })


  if (agentAsHomeownerRepresentative === 'myself' && (isBelow10K || isFinancingRejected || isBosscatFinancing)) {
    steps.push({
      content: <Step4Agent />,
      disableBack: true,
    })
  }

  useEffect(() => {
    if (estimate?.properties?.address?.zipCode)
      dispatch(territoriesActions.fetchTerritory(estimate?.properties?.address?.zipCode))
  }, [estimate])

  return (
    <>
      {/* <ContactBanner /> */}

      <Stepper
        showHeader={estimate?.properties.financingApprovedOn ? false : true}
        steps={steps}
        activeStep={activeStep}
        setActiveStepAction={(step: number) =>
          dispatch(approvalActions.setApprovalStep(step))
        }
        saveNewValueAction={(value: ApprovalValue) =>
          dispatch(approvalActions.setApprovalValue(value))
        }
      />
    </>
  )
}

export default HomeownerStepper
